import { styled } from '@mui/material/styles';
import { DatagridConfigurable } from 'shared/react-admin/Datagrids';
import { ImageField } from 'shared/react-admin/Fields';
import { getColumnStyle } from 'utils';

export const DatagridConfigurableStyled = styled(DatagridConfigurable)(({ theme }) => ({
  '.RaDatagrid-headerCell': {
    verticalAlign: 'middle',
    backgroundColor: theme.palette.tableHead,
  },
  '& .column-undefined': { width: '100%', minWidth: '100%' },
  '& .column-amount': {
    ...getColumnStyle(136),
    textAlign: 'right',
  },
  '& .column-originId': getColumnStyle(113),
  '& .resize-method': getColumnStyle(190),
  '& .resize-gateway': getColumnStyle(191),
  '& .resize-merchantReference': getColumnStyle(156),
  '& .resize-providerReferenceId': getColumnStyle(161),
  '& .column-createdAt': getColumnStyle(114),
  '& .column-currency': getColumnStyle(94),
  '& .resize-commission-rule': getColumnStyle(163),
  '& .resize-direction': getColumnStyle(129),
  '& .resize-merchantAccount': getColumnStyle(280),
  '& .resize-totalAmount': {
    ...getColumnStyle(116),
    textAlign: 'right',
    whiteSpace: 'initial !important',
  },
  '& .column-commissionValueByCurrencyOrder': {
    ...getColumnStyle(130),
    textAlign: 'right',
    whiteSpace: 'initial !important',
  },
  '& .column-commissionValueByCurrencyCommission': {
    ...getColumnStyle(138),
    textAlign: 'right',
    whiteSpace: 'initial !important',
  },
  '& .column-merchantAccount': {
    minWidth: '134px',
    maxWidth: '280px',
  },
}));

export const ImageFieldStyled = styled(ImageField)({
  '& .RaImageField-image': {
    margin: 0,
    marginRight: '2px',
    maxWidth: 24,
    maxHeight: 24,
    minWidth: 24,
    minHeight: 24,
    objectFit: 'contain',
  },
});
